@if (loading) {
  <div class="flex items-center justify-center py-10">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
} @else {
  <!-- Top Container -->
  <div
    class="mt-2 font-lato font-normal md:flex md:items-center md:justify-between md:gap-4"
  >
    <nav class="min-w-0 flex-1" aria-label="Order detail breadcrumb">
      <ol
        class="flex flex-wrap items-center gap-x-2 gap-y-1 text-lg font-semibold text-[#0f2744] md:text-xl"
      >
        <li>
          <button
            type="button"
            class="rounded text-left text-lg font-semibold text-[#0D62FF]/70 underline decoration-[#0D62FF]/35 underline-offset-4 transition-colors hover:text-[#0D62FF] hover:decoration-[#0D62FF] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0D62FF] md:text-xl"
            (click)="goBack()"
          >
            Orders List
          </button>
        </li>
        <li
          class="select-none font-semibold text-[#0f2744]/45"
          aria-hidden="true"
        >
          &gt;
        </li>
        <li class="min-w-0 truncate" aria-current="page">
          {{ order.nit }}
        </li>
      </ol>
    </nav>

    <!-- Right Actions -->
    <div class="mt-4 flex flex-shrink-0 flex-wrap md:mt-0">
      <button class="btn-primary" (click)="onCreateTicket()">
        Create Ticket
      </button>
    </div>
  </div>
}

<!-- Order Data -->
<div class="mt-5 gap-5 font-lato font-normal md:flex md:justify-between">
  <!-- Column 1 -->
  <div class="flex flex-1 flex-col gap-5">
    <app-order-details-box
      class="w-full"
      title="General Information"
      [data]="generalInfo"
    />

    @if (!datesInCenter) {
      <app-order-dates-box class="w-full" [dates]="keyDates" />
    }
  </div>

  <!-- Column 2 -->
  <div class="flex flex-1 flex-col gap-5">
    @if (basicServiceInfo?.length > 0) {
      <app-order-details-box
        class="w-full"
        title="Basic Service Information"
        [data]="basicServiceInfo"
      />
    }

    @if (datesInCenter) {
      <app-order-details-box
        class="w-full"
        title="Circuit Order Specifics"
        [data]="circuitOrdersInfo"
      />
    } @else {
      <app-order-dates-box class="w-full" [dates]="keyDates" />
    }
  </div>

  <!-- Column 3 -->
  <div class="flex flex-1 flex-col gap-5">
    <app-order-contacts-box class="w-full" [data]="contactsInfo" />
  </div>
</div>
